<template>
    <div>
        <v-offline
                online-class="online"
                offline-class="offline"
                @detected-condition="amIOnline">
            <template v-slot:[onlineSlot] :slot-name="onlineSlot">
                {{ onlineOfflineMsg }}
            </template>
            <template v-slot:[offlineSlot] :slot-name="offlineSlot">
                {{ onlineOfflineMsg }}
            </template>
        </v-offline>
        <div class="row">
            <div class="col-lg-12">
                <div class="ibox ">
                    <div class="ibox-content">
                        <div class="panel-heading">
                            <h2 class="set_font_title">Area Details</h2>
                        </div>
                        <div class="row col-md-12 col-xl-12">
                            <div class="col-sm-12 col-md-12 col-lg-12">
                                <div class="card setShadow">
                                    <div class="card-body" style="padding: 15px 15px 0px;">
                                        <div class="row">
                                            <div class="col-sm-6">
                                                <div style="padding-top: 10px;">
                                                    <a :title="title" href="#"
                                                       style="float: left; font-size: 22px; font-weight: bold;">
                                                        {{ title }}
                                                    </a>
                                                </div>
                                            </div>
                                            <div v-if="!isReadOnly" class="col-sm-6 text-right">
                                                <button v-bind:disabled="!onLine" type="submit"
                                                        class="btn btn-primary"
                                                        @click="editArea(areaId)">Edit Area
                                                </button>
                                                <button v-bind:disabled="!onLine" type="submit"
                                                        class="btn btn-primary"
                                                        @click="kmlDownload(areaImage)">Download KML
                                                </button>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="row">
                                            <div class="col-sm-12 col-md-4 pb-2">
                                                <MapBase
                                                    height="350px"
                                                    :enableKml="true"
                                                    :kmlFiles="[areaImage]"
                                                    :zoom="10"
                                                />
                                            </div>
                                            <div class="col-sm-12 col-md-6 contain_card">
                                                <div class="area-details">
                                                    <p class="area-info-text">Created On <br> <span
                                                            class="area-details-text">{{
                                                            createdOn.toLocaleString()
                                                        }}</span></p>
                                                    <p class="area-info-text">Country <br> <span
                                                            class="area-details-text">{{ country }}</span></p>
                                                    <p class="area-info-text">State/Province <br> <span
                                                            class="area-details-text">{{
                                                            areaState != 'null' ? areaState : 'Not specified'
                                                        }}</span></p>
                                                    <p class="area-info-text">City/District/Village <br> <span
                                                            class="area-details-text">{{ locality }}</span></p>

                                                    <p class="footer_tags text-left">
<!--                                                        <b-icon-circle-fill
                                                                :style="{ color: catchReleaseStatus.color }"
                                                        />-->
                                                        {{ catchReleaseStatus.text }}
                                                    </p>

                                                    <p class="footer_tags text-left">
<!--                                                        <b-icon-circle-fill
                                                                :style="{ color: releaseStatus.color }"
                                                        />-->
                                                        {{ releaseStatus.text }}
                                                    </p>

                                                    <p class="footer_tags text-left">
<!--                                                        <b-icon-triangle-fill
                                                                :style="{ color: clinicStatus.color }"
                                                        />-->
                                                        {{ clinicStatus.text }}
                                                    </p>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <br>

                        <div class="row setTitleDiv">
                            <p>Records</p>
                        </div>
                        <div class="row col-md-12 col-xl-12">
                            <div class="col-sm-12 col-md-12 col-xl-6">
                                <div class="card setShadow">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <b style="font-size: 17px !important;color: #9a9a9a !important;">Catch-Release</b>
                                                <hr>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-6">
                                                <b>Caught Count</b>
                                                <div style="font-size: 24px;">
                                                    {{ caughtCount }}
                                                </div>
                                                <p v-if="catchOutAreaCount>0">Of which {{
                                                        catchOutAreaCount
                                                    }} animals are out-of-area</p>
                                            </div>
                                            <div class="col-sm-6">
                                               <button v-bind:disabled="!onLine" type="submit"
                                                       class="btn btn-primary" @click="listAreaCatchReleaseRecords">
                                                   List
                                               </button>
                                               <button v-bind:disabled="!onLine" type="submit"
                                                       class="btn btn-primary" @click="viewAreacatchReleaseOnMap">Map
                                               </button>
                                           </div>
                                        </div>
                                    </div>
                                </div>
                            </div>




                        </div>

                        <div class="row col-md-12 col-xl-12">
                            <div class="col-sm-12">
                                <div class="card setShadow">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <b style="font-size: 17px !important;color: #9a9a9a !important;">Animals at Each Stage</b>
                                                <hr>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col">
                                                <b>Awaiting Exam</b>
                                                <div style="font-size: 24px;">
                                                    {{ awaiting_evaluation }}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <b>Pre-Op Hold</b>
                                                <div style="font-size: 24px;">
                                                    {{ pre_op_hold }}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <b>Sterilized</b>
                                                <div style="font-size: 24px;">
                                                    {{ sterilized }}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <b>Post-Op Hold</b>
                                                <div style="font-size: 24px;">
                                                    {{ post_op_hold }}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <b>Cleared for Release</b>
                                                <div style="font-size: 24px;">
                                                    {{ cleared_for_release }}
                                                </div>
                                            </div>
                                            <div class="col">
                                                <b>Released Out of Care</b>
                                                <div style="font-size: 24px;">
                                                    {{ released_out_of_care }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <br>

                        <div class="row setMarginTop set_res_margin_top">
                            <div class="col-xs-12 col-md-12 col-xl-12">
                                <div class="row setTitleDiv">
                                    <p>Field User Assignments - Catch-Release</p>
                                </div>
                                <div class="row col-md-12 col-xl-12">
                                    <div class="col-sm-12 col-md-12 col-xl-12">
                                        <div class="card setShadow"
                                             style="overflow: scroll; position: relative; border: 0px; width: 100%;">
                                            <div class="card-body text_left">
                                                <table id="example"
                                                       class="display table table-striped table-bordered select"
                                                       cellspacing="0" width="100%">
                                                    <thead>
                                                    <tr>
                                                        <th>Name</th>
                                                        <th>Email</th>
                                                        <th>Role</th>
                                                        <th>Status</th>
                                                        <th>#Records</th>
                                                        <th v-if="!isReadOnly"><span style="color: rgb(19, 206, 102);">Active</span> /
                                                            <span
                                                                    style="color: rgb(255, 73, 73);">De-Active</span>
                                                        </th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr v-for="(item, index) in catchReleaseAssignedUsers" :key="index">
                                                        <td>{{ item.first_name + " " + item.last_name }}</td>
                                                        <td>{{ item.email }}</td>
                                                        <td>{{ item.purpose }}</td>
                                                        <td>
                                                            <b-icon-circle-fill
                                                                    :style="{ color: item.statusColor }"/>
                                                            <template v-if="item.submissionStatus=='Closed/Submitted'">
                                                                {{ item.submissionStatus }}<br>
                                                                <button v-if="!isReadOnly" style="border: none; background: none; color:lightseagreen;"
                                                                        @click='reassignArea(item.assignationId)'>
                                                                    Re-Open
                                                                </button>
                                                            </template>
                                                            <template v-else>
                                                                {{ item.submissionStatus }}
                                                            </template>
                                                        </td>
                                                        <td>{{ item.recordsCount }}</td>
                                                        <td v-if="!isReadOnly">
                                                            <el-switch
                                                                    v-model="item.activeStatus"
                                                                    @change="changeUserActiveStatus(item)"
                                                                    active-color="#13ce66"
                                                                    inactive-color="#ff4949">
                                                            </el-switch>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-sm-12">
                                        <p>De-activating stops further submissions from the field user, but keeps any
                                            data they have entered. It also considers their data "submitted" as it
                                            relates to determine if an area is Submitted/Finalized</p>
                                    </div>

                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import mixin from '../../../mixins/GlobalMixin';
import {Switch} from 'element-ui';
import VOffline from 'v-offline';
import {BIconTriangleFill, BIconCircleFill} from "bootstrap-vue";
import MapBase from '../../map/MapBase.vue';

export default {
    components: {
        VOffline,
        [Switch.name]: Switch,
        BIconTriangleFill,
        BIconCircleFill,
        MapBase
    },
    props: {
        projectId: {
            type: Number,
        },
        areaId: {
            type: Number,
        }
    },
    data()
    {
        return {
            isReadOnly:false,
            title: 'title',
            createdOn: '',
            country: '',
            areaState: '',
            locality: '',
            areaImage: '',
            areaId: '',
            caughtCount: 0,
            awaiting_evaluation: 0,
            pre_op_hold: 0,
            sterilized: 0,
            post_op_hold: 0,
            cleared_for_release: 0,
            released_out_of_care: 0,
            operatedCount: 0,
            notOperatedCount: 0,
            clinics: '',
            catchRelease: '',
            catchReleaseImg: '',
            catchReleaseName: '',
            clinicsImg: '',
            clinicsName: '',
            catchReleaseAssignedUsers: null,
            clinicAssignedUsers: null,
            areaStatusColor: 'black',
            catchReleaseRecLen: 0,
            catchOutAreaCount: 0,
            catchReleaseRecPer: 0,
            clinicsRecLen: 0,
            clinicsRecPer: 0,
            catchReleaseStatus: {
                type: Object
            },
            releaseStatus: {
                type: Object
            },
            clinicStatus: {
                type: Object
            }
        }
    },
    mixins: [mixin],
    methods: {
        viewAreacatchReleaseOnMap()
        {
            localStorage.setItem('vaccinationProjectLevelViewMap', 0);
            localStorage.setItem('VaccinationAreaId', this.areaId);
            localStorage.setItem('VaccinationAreaName', this.title);
            this.$router.push({
                name: 'areaCatchReleaseMapview',
                params: {projectId: this.projectId, areaId: this.areaId}
            })
        },
        showAllKMLs()
        {
            window.location = '/project/map_kml_files/' + this.areaId;
        },
        listAreaClinicRecords()
        {

        },
        listAreaCatchReleaseRecords()
        {
            localStorage.setItem('vaccinationProjectLevelViewList', 0);
            localStorage.setItem('VaccinationAreaId', this.areaId);
            localStorage.setItem('VaccinationAreaName', this.title);
            this.$router.push({name: 'areaCatchReleaseList', params: {projectId: this.projectId, areaId: this.areaId}})
        },
        viewAreaClinicOnMap()
        {
            localStorage.setItem('clinicProjectLevelViewMap', 0);
            localStorage.setItem('ClinicAreaId', this.areaId);
            localStorage.setItem('ClinicAreaName', this.title);
            this.$router.push({name: 'areaClinicMapview', params: {projectId: this.projectId, areaId: this.areaId}})
        },
        listAreaClinics()
        {
            localStorage.setItem('clinicProjectLevelViewList', 0);
            localStorage.setItem('ClinicAreaId', this.areaId);
            localStorage.setItem('ClinicAreaName', this.title);
            this.$router.push({name: 'areaClinicList', params: {projectId: this.projectId, areaId: this.areaId}})
        },
        getAreaDetails(areaId)
        {
            axios.get("/area/details/pm/" + areaId)
                .then(response => {
                    if (response.data.response.error.error_code == 0) {
                        let areaDetails = response.data.response.data.area;
                        let vm = this;

                        vm.catchOutAreaCount = areaDetails.caught_out_of_area_count
                        vm.caughtCount = areaDetails.caught_count
                        vm.operatedCount = areaDetails.operated_records
                        vm.notOperatedCount = areaDetails.not_operated_records

                        vm.awaiting_evaluation = areaDetails.awaiting_evaluation
                        vm.pre_op_hold = areaDetails.pre_op_hold
                        vm.sterilized = areaDetails.sterilized
                        vm.post_op_hold = areaDetails.post_op_hold
                        vm.cleared_for_release = areaDetails.cleared_for_release
                        vm.released_out_of_care = areaDetails.released_out_of_care

                        vm.catchReleaseStatus = areaDetails.status_info.catch;
                        vm.releaseStatus = areaDetails.status_info.release;
                        vm.clinicStatus = areaDetails.status_info.clinic;

                        vm.areaStatusColor = areaDetails.status_color_code;

                        vm.title = areaDetails.name;
                        vm.createdOn = new Date(areaDetails.created_at);
                        vm.country = areaDetails.google_country;
                        vm.areaState = areaDetails.google_admin_area_level1;
                        vm.locality = areaDetails.google_locality;
                        vm.areaImage = areaDetails.file_url;
                        vm.areaId = areaDetails.id;
                        let assigned_clinic_areas = response.data.response.data.area.assigned_areas;
                        let assignedUsers = [];
                        for (let i = 0; i < assigned_clinic_areas.length; i++) {
                            let assignedArea = assigned_clinic_areas[i];
                            if (assignedArea.user == null) {
                                continue;
                            }
                            let user = assignedArea.user;
                            user.assignationId = assignedArea.id;
                            if (assignedArea.purpose == 1) {
                                user.purpose = 'Clinic';
                                user.recordsCount = areaDetails.clinics.filter(x => x.record_taken_by == assignedArea.user_id).length
                            } else
                                if (assignedArea.purpose == 3) {
                                    user.purpose = 'Catch-Release';
                                    user.recordsCount = 0;
                                    user.recordsCount = areaDetails.catched.filter(x => x.caught_by_id == assignedArea.user_id).length
                                    user.recordsCount += areaDetails.released.filter(x => x.released_by_id == assignedArea.user_id).length
                                }

                            if (assignedArea.status == 0) {
                                user.submissionStatus = "Ready to start";
                                user.statusColor = "#00ff00";
                            } else
                                if (assignedArea.status == 1) {
                                    user.submissionStatus = "In progress";
                                    user.statusColor = "#ffff00";
                                } else
                                    if (assignedArea.status == 5) {
                                        user.submissionStatus = "Closed/Submitted";
                                        user.statusColor = "#ff0000";
                                    } else
                                        if (assignedArea.status == -1) {
                                            user.submissionStatus = "Re-Opened";
                                            user.statusColor = "#808080";
                                        }

                            // this.$set(user, 'recordId', assignedArea.id)
                            // this.$set(user, 'areaId', assignedArea.area_id)
                            // this.$set(user, 'activeStatus', assignedArea.is_active)
                            user.recordId = assignedArea.id
                            user.areaId = assignedArea.area_id
                            user.activeStatus = Boolean(assignedArea.is_active)
                            assignedUsers.push(user);
                        }
                        vm.catchReleaseAssignedUsers = assignedUsers.filter(x => x.purpose == "Catch-Release");
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        },
        reassignArea(assignmentId)
        {
            let vm = this;
            axios.post("/area/reassign/" + assignmentId, {})
                .then(response => {
                    if (response.data.response.error.error_code == 0) {
                        vm.showAlert('Success', response.data.response.error.msg, true, function (result) {
                            if (result.value) {
                                vm.getAreaDetails(vm.areaId);
                            }
                        });
                    }
                })
                .catch(error => {
                    vm.showAlert('Failed', response.data.response.error.error_msg, false);
                });
        },
        getAllAreaDetails(project_id)
        {
            axios.get("/area/all/details/" + project_id)
                .then(response => {
                    if (response.data.response.error.error_code == 0) {
                        let vm = this;
                        let assigned_clinic_areas = response.data.response.data.assigned_clinic_areas;
                        let assigned_vaccination_areas = response.data.response.data.assigned_vaccination_areas;
                        let clinic = this.getUnique(Object.keys(assigned_clinic_areas).flatMap((itm) => assigned_clinic_areas[itm].user).filter(x => !!x), 'email');
                        let vaccination = this.getUnique(Object.keys(assigned_vaccination_areas).flatMap((itm) => assigned_vaccination_areas[itm].user).filter(x => !!x), 'email');
                        vm.catchReleaseAssignedUsers = vm.matchUserRecord(clinic, vaccination).filter(x => !!x);
                    }
                })
                .catch(error => {
                    if (error.response.data.response.error) {

                    }
                });
        },
        getUnique(arr, comp)
        {

            const unique = arr
                .map(e => e[comp])

                // store the keys of the unique objects
                .map((e, i, final) => final.indexOf(e) === i && i)

                // eliminate the dead keys & store unique objects
                .filter(e => arr[e]).map(e => arr[e]);

            return unique;
        },
        editArea(id)
        {
            //this.areaId = id;
            //window.location = '/project/edit_area/' + this.areaId;
            this.$router.push({name: 'editAreaPm', params: {areaId: id}})
        },
        view_download_kml(area_id)
        {
            window.location = '/project/view_download_kml/' + area_id;
        },
        kmlDownload(kmlFileUrl)
        {
            window.location.href = kmlFileUrl;
        },
        async changeUserActiveStatus(user)
        {
            console.log('user', user)
            const url = '/area/toggle_active_user';
            const query = {
                id: user.recordId,
                user_id: user.id,
                area_id: user.areaId,
                purpose: user.purpose === 'Clinic' ? 1 : user.purpose === 'Vaccinator' ? 2 : 3
            }
            try {
                const response = await axios.post(url, null, {
                    params: query
                })
            } catch (error) {
                user.activeStatus = !user.activeStatus
                this.showAlert('Error', error.response.data.message, false);
            }
        }
    },
    computed: {
        getcatchReleasetats: function () {
            return this.catchReleaseRecLen;
        },
        getClinicStats: function () {
            if (this.clinicsRecLen > 10) {
                return this.clinicsRecLen + ' (' + this.clinicsRecPer + '%)';
            }
            return "Not enough data";
        }
    },
    mounted()
    {
        let vm = this;
        vm.project = vm.$store.getters.getCurrentSelectedProject;
        vm.isReadOnly = false
        vm.$store.getters.getUserRoleForCurrentProject.forEach(r => {
            if(r.role_name == 'VIEWER'){
                vm.isReadOnly = true
            }
        })
        //this.areaId = vm.project.id;
        //Bus.$emit("projectype", vm.project);
        let url = location.href;
        let res = url.split("/");
        this.areaId = res[res.length - 1];
        vm.getAreaDetails(vm.areaId);
    }
}

</script>
<style scoped>

table {
    text-align: center;
}

.pac-card {
    margin: 10px 10px 0 0;
    border-radius: 2px 0 0 2px;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    outline: none;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    background-color: #fff;
}

#pac-container {
    padding-top: 12px;
    padding-bottom: 12px;
    margin-right: 12px;
}

.pac-controls label {
    font-size: 13px;
    font-weight: 300;
}

#pac-input {
    background-color: #fff;
    font-size: 15px;
    font-weight: 300;
    margin-left: 12px;
    padding: 0 11px 0 13px;
    text-overflow: ellipsis;
    width: 100%;
    max-width: 400px;
}

#pac-input:focus {
    border-color: #4d90fe;
}

#title {
    color: #fff;
    background-color: #4d90fe;
    font-size: 25px;
    font-weight: 500;
    padding: 6px 12px;
}

.setTitleDiv p {
    font-size: 17px;
    font-weight: 600;
    color: black;
}

.el_select_width {
    width: 100% !important;
}

.setShadow {
    box-shadow: 0 6px 10px 0px rgba(0, 0, 0, 0.15) !important;
}

.card .numbers p {
    color: #9A9A9A;
    font-size: 14px;
}

.card .numbers {
    font-size: 1.5em !important;
}

.card .card-body {
    text-align: center;
}

.set_b_font_card {
    font-size: 17px !important;
    color: #9a9a9a !important;
}

.set_btn {
    text-align: right;
    margin-top: -5px;
}

@media (max-width: 768px) {
    .set_btn {
        text-align: center !important;
        margin-top: -5px;
    }
}

.btn_card {
    cursor: pointer;
    height: 86px;
}

.no_rec_msg {
    font-size: 20px;
    height: 220px;
}

.text-field__filled {
    display: block;
    font-size: 18px;
    padding: 4px 10px 10px 5px;
    width: 100% !important;
    border: none;
    border-bottom: 1px solid #757575;
}

.set_font_title {
    font-size: 20px !important;
    font-weight: 600 !important;
    color: black !important;
    margin-left: -12px !important;
}

p {
    margin-bottom: 12px;
}

p {
    cursor: default;
}

.card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.area-img {
    width: 200px;
    height: 220px;
}

.area-details {
    margin-bottom: 15px;
}

.area-title {
    margin: 0;
    font-size: 18px;
    font-weight: bold;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    cursor: pointer;
}

.area-contributors {
    float: left;
}

.area-card-footer {
    margin-left: 15px;
    margin-right: 15px;
}

.contain_card {
    text-align: left !important;
}

.card_height {
    height: 260px !important;
}

.set_contain {
    margin-left: 3px;
    text-align: left;
    margin-bottom: 10px;
}

.set_font {
    font-size: 25px;
    margin-left: 15px;
}

.zoom_icon {
    font-size: 20px;
    cursor: pointer;
    color: #009CEB;
}

.area-details-text {
    font-weight: bold;
    margin-bottom: 5px;
}

</style>
